

























import { defineComponent } from '@vue/composition-api';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import PresentOccupation from '@front-app/components/userProfile/main/PresentOccupation.vue';
import TrStepperPrevNext from '@front-app/components/stepper/TrStepperPrevNext.vue';
import StepperHeader from '@front-app/components/stepper/StepperHeader.vue';
import { STEP_PROPS } from './steps';

export default defineComponent({
	components: { PresentOccupation, TrStepperPrevNext, StepperHeader },
	props: STEP_PROPS,
	setup() {
		const { currentUser } = CurrentUserStore;
		return {
			currentUser,
		};
	},
});
